<template>
  <div class="wetlandMsgPage">
    <van-cell-group class="forestInput">
      <van-field
        v-model="baseData.num"
        readonly
        :label="$t('wetlandMsg.wetlandNumberTit') + '：'"
      />
      <van-field
        v-model="baseData.name"
        readonly
        :label="$t('wetlandMsg.wetlandNameTit') + '：'"
      />
      <van-field
        v-model="baseData.alias"
        readonly
        :label="$t('wetlandMsg.aliasTit') + '：'"
      />
      <van-field
        v-model="baseData.yztNd"
        readonly
        :label="$t('common.yearTit') + '：'"
      />
      <van-field
        v-model="baseData.address"
        readonly
        :label="$t('common.politicalTit') + '：'"
      />
      <van-field
        v-model="baseData.diLei"
        readonly
        :label="$t('wetlandMsg.DiLeiTit') + '：'"
      />
      <van-field
        v-model="baseData.diXing"
        readonly
        :label="$t('wetlandMsg.DiXingTit') + '：'"
      />
      <van-field
        v-model="baseData.mianJi"
        readonly
        :label="$t('wetlandMsg.MainJiTit') + '：'"
      />
      <van-field
        v-model="baseData.zbLx"
        readonly
        :label="$t('wetlandMsg.zbLxTit') + '：'"
      />
      <van-field
        v-model="baseData.dcSj"
        readonly
        :label="$t('wetlandMsg.dcSjTit') + '：'"
      />
      <van-field
        v-model="baseData.dcDw"
        readonly
        :label="$t('wetlandMsg.dcDwTit') + '：'"
      />
      <van-field
        v-model="baseData.bhName"
        readonly
        :label="$t('wetlandMsg.bhNameTit') + '：'"
      />
      <van-field
        v-model="baseData.yiLyName"
        readonly
        :label="$t('wetlandMsg.yiLyNameTit') + '：'"
      />
      <van-field
        v-model="baseData.ejLyName"
        readonly
        :label="$t('wetlandMsg.ejLyNameTit') + '：'"
      />
      <van-field
        v-model="baseData.glName"
        readonly
        :label="$t('wetlandMsg.glNameTit') + '：'"
      />
      <van-field
        v-model="baseData.remarks"
        rows="3"
        autosize
        type="textarea"
        readonly
        :label="$t('common.explainTit') + '：'"
      />
    </van-cell-group>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "wetlandMsg",
  data() {
    return {
      wetlandId: "", //湿地Id
      baseData: {},
      refreshPage: false,
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "湿地信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.wetlandId = this.$route.query.commonId;
      if (this.wetlandId == undefined) {
        this.wetlandId = this.param.id;
      }
      this.initPage();
    });
    // this.wetlandId = "841";
    // this.initPage();
  },
  components: {
    refreshPage,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .wetlandMsg(_this.wetlandId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.wetlandId = _this.param.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.wetlandMsgPage {
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>